"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsValidationSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.DocumentsValidationSchema = zod_1.z
    .object({
    plantList: zod_1.z.string().url(),
    investmentBasicInformation: zod_1.z.string().url(),
    investmentInformation: zod_1.z.string().url(),
    investmentConditions: zod_1.z.string().url(),
    rentalAgreement: zod_1.z.string().url(),
    expertProtocol: zod_1.z.string().url(),
    landRegister: zod_1.z.string().url(),
    energyCertificate: zod_1.z.string().url(),
    utilityReport: zod_1.z.string().url(),
    additionalDocuments: zod_1.z.array(enums_1.ImageValidationSchema),
    additionalInvestmentDocuments: zod_1.z.array(enums_1.SignedImageValidationSchema),
    scenarioCalculations: zod_1.z.string().url(),
})
    .partial();
//# sourceMappingURL=documents.js.map